import { render, staticRenderFns } from "./MultiplechoiceModule.vue?vue&type=template&id=a8ee50da&scoped=true"
import script from "./MultiplechoiceModule.vue?vue&type=script&lang=js"
export * from "./MultiplechoiceModule.vue?vue&type=script&lang=js"
import style0 from "./MultiplechoiceModule.vue?vue&type=style&index=0&id=a8ee50da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ee50da",
  null
  
)

export default component.exports